/**
 * Http Axios Setting
 *
 * @author minkyoung.park@emcast.com
*/
// Reference Site : https://gist.github.com/paulsturgess/ebfae1d1ac1779f18487d3dee80d1258
import Vue from 'vue'
import 'es6-promise/auto'
import axios from 'axios'
import LocalStorageUtil from "@/utils/localStorageUtil";
import { ACCESS_KEY, makeSignatureKey } from '@/utils/accessApiKeyUtil'

const options = {
	headers: {
		'Content-Type': 'application/json'
	}
}

// Set Http Serveice
class httpService {
	constructor() {
		let service = axios.create({
			options,
			headers: {
                "X-ClientAccessKey": ACCESS_KEY,
            }
		})

		service.interceptors.response.use(this.handleReponseSuccess, this.handleReponseError)
		service.interceptors.request.use(this.handleRequestSuccess, this.handleRequestError)
		this.service = service

	}

	handleRequestSuccess = (config) => {
		if (LocalStorageUtil.getToken()) {
			config.headers.authToken = LocalStorageUtil.getToken();
		}
		config.headers["X-ClientSignature"] = makeSignatureKey();
		return config
	}

	handleRequestError = (error) => {
		return Promise.reject(error)
	}

	handleReponseSuccess = (response) => {
		// console.log('handleReponseSuccess ', response);
		// if (response.headers["content-type"] && response.headers["content-type"].includes("text/html")) {
		// 	document.location = response.request.responseURL;
		// }
		return response
	}

	handleReponseError = (error) => {
		// console.log('error.response.status', error.response)
		// switch (error.response.status) {
		// case 401:
		// 	router.push(`/login?rPath=${encodeURIComponent(location.pathname)}`)
		// 	break;
		// case 404:
		// 	router.push(`/404`)
		// 	break;
		// case 500:
		// 	router.push(`/500`)
		// 	break;
		// 	// default:
		// 	//     this.redirectTo(document, '/500')
		// 	//     break;
		// }


		return Promise.reject(error)
		//return error
	}

	redirectTo = (document, path) => {
		document.location = path
	}


	get(path, payload) {
		return this.service.request({
			method: 'GET',
			url: localStorage.getItem('VUE_APP_API_HOST') + path,
			responseType: 'json',
			params: payload
		})
	}


	put(path, payload) {
		return this.service.request({
			method: 'PUT',
			url: localStorage.getItem('VUE_APP_API_HOST') + path,
			responseType: 'json',
			data: payload
		})
	}

	delete(path, payload) {
		return this.service.request({
			method: 'DELETE',
			url: localStorage.getItem('VUE_APP_API_HOST') + path,
			responseType: 'json',
			data: payload
		})
	}

	getExternal(path, responseType, payload) {
		return this.service.request({
			method: 'GET',
			url: path,
			responseType: responseType,
			params: payload
		})
	}

	patch(path, payload) {
		return this.service.request({
			method: 'PATCH',
			url: localStorage.getItem('VUE_APP_API_HOST') + path,
			responseType: 'json',
			data: payload
		})
	}

	upload(formData) {
		return this.service.request({
			headers: {
			  'Content-Type': 'multipart/form-data'
			},
			method: 'POST',
			url: localStorage.getItem('VUE_APP_API_HOST') + '/common/attachment',
			responseType: 'json',
			data: formData,
		})
	}


	post(path, payload) {
		return this.service.request({
			method: 'POST',
			url: localStorage.getItem('VUE_APP_API_HOST') + path,
			responseType: 'json',
			data: payload
		})
	}

	dummy(data, timeout) {
		return new Promise((resolve, reject) => {
			setTimeout(function () {

				resolve(data)
			}, timeout)
		})
	}

	custom(method, path, responseType, payload) {
		return this.service.request({
			method: method,
			url: path,
			responseType: responseType,
			params: payload
		})
	}

	fileDownload(url) {
		return this.service.request({
			method: 'get',
			url: url,
			responseType: 'arraybuffer'
		})
	}

	// Set Auth token in header
	setAuthInHeader(token) {
		this.service.defaults.headers.common['authToken'] = token ? token : null
	}


}

export default new httpService
